export const ROLE_POLICY_TYPE = {
  managed: 'Managed',
  inline: 'Inline',
};
